<template>
  <v-data-table
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasRespondidas"
    class="respo elevation-1"
    hide-default-footer
    disable-pagination
    :expanded.sync="expanded"
    item-key="perguntaMunicipioId"
  >
    <template v-slot:item="props">
      <tr>
        <td>{{ props.item.nome }}</td>
        <td>
          <div>
            <div>{{ props.item.texto }}</div>
          </div>
        </td>

        <td
          @click="
            () => {
              $emit('openEvidence', props.item);
              verComplemento = !verComplemento;
            }
          "
          v-if="props.item.temArquivo"
        >
          <div class="optionsExpanded">
            <v-btn
              color="azulclarosc"
              class="ml-3"
              style="color: #fff"
              v-if="
                isFullAdmin ||
                (groupsConfig.visualizarRejeitadas &&
                  config.visualizarRejeitadas)
              "
            >
              <span
                v-if="
                  expanded.length > 0 &&
                  props.item.perguntaMunicipioId ===
                    expanded[0].perguntaMunicipioId
                "
                >esconder arquivos</span
              >
              <span v-else>mostrar arquivos</span>
            </v-btn>
          </div>
        </td>
        <td v-else></td>
        <td width="300px">
          <v-form
            ref="file"
            lazy-validation
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-file-input
              accept="application/pdf, application/vnd.ms-excel"
              v-if="
                isFullAdmin ||
                (groupsConfig.enviarRespondidas && config.enviarRespondidas)
              "
              :rules="rulesArquivo"
              label="Selecione Arquivos de Evidência"
              v-model="props.item.arquivos"
            >
            </v-file-input>
          </v-form>
        </td>
        <td>
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-btn
              color="primary"
              class="ml-3"
              @click="checkCarregar(props.item)"
            >
              <span>Carregar</span>
            </v-btn>
          </template>
        </td>
        <td v-if="props.item.evidencia && props.item.evidenciada === false">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            :title="'Clique para exibir as características da evidência que deve ser apresentada'"
            v-if="props.item.evidencia.length > 0"
            :isHtml="true"
          >
          </app-modal-show-evidence>
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="props">
      <tr class="complemento expanded" v-if="evidences && evidences.length > 0">
        <td colspan="7" class="evidencias">
          <h1 class="titulo2">Evidências</h1>
          <div class="agrupEvidencias">
            <div
              class="nomeEvidencia"
              v-for="(ev, index) in evidences"
              :key="index"
            >
              <span @click="downloadEvidence(ev)">{{ ev.nomeArquivo }}</span>
              <v-btn
                outlined
                color="error"
                class="ml-3"
                @click="perguntaDelete(ev)"
                v-if="
                  isFullAdmin ||
                  !isSala ||
                  (isSala &&
                    JSON.parse(config.visualizaEixosIds || '[]').includes(
                      props.item.eixoId
                    ))
                "
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </div>
          </div>
        </td>
      </tr>
      <tr
        class="complemento"
        v-if="props.item.perguntaId == 3 && evidences && evidences.length > 0"
      >
        <td colspan="7">
          <h1 class="titulo">Dados complementares obrigatórios</h1>
          <div>
            <div class="d-flex perguntas">
              <div class="_nome">
                Mínimo de horas por atendente informado no(s) arquivo(s)
                carregados acima (incluindo as 04 horas mínimas de capacitação
                em Compras Governamentais)
              </div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="props.item.valorInformado"
                  outlined
                  placeholder="0"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <hr />
            <div class="d-flex perguntas">
              <div class="_nome">
                Quantidade de atendentes informada no
                <strong>diagnóstico</strong>
              </div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="valorDiagnostico"
                  outlined
                  disabled
                  placeholder="0"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <hr />
            <div class="d-flex perguntas">
              <div class="_nome">Quantidade atual de atendentes</div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="props.item.atualizacaoAtendentes"
                  outlined
                  placeholder="0"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <template
              v-if="
                parseInt(valorDiagnostico) !=
                parseInt(props.item.atualizacaoAtendentes)
              "
            >
              <hr />
              <div class="d-flex perguntas">
                <div class="_nome">
                  Selecione o arquivo da declaração da alteração da quantidade
                  de atendentes (caso tenha ocorrido)
                </div>
                <div>
                  <v-file-input
                    accept="application/pdf, application/vnd.ms-excel"
                    :rules="rulesArquivo"
                    style="width: 300px"
                    label="Selecione o arquivo"
                    v-model="props.item.arquivosDados"
                    placeholder="Selecione o arquivo"
                    hide-details="auto"
                    outlined
                  >
                  </v-file-input>
                </div>
              </div>
            </template>
          </div>
        </td>
      </tr>
      <tr
        class="complemento expanded"
        v-if="props.item.perguntaId !== 3 ? props.item.temArquivo : true"
      >
        <td colspan="7">
          <div class="d-flex" style="justify-content: flex-end">
            <v-btn
              color="primary"
              class="ml-3"
              @click="checkSalvarDados(props.item)"
            >
              <span>Salvar</span>
            </v-btn>
            <v-btn
              color="azulclarosc"
              class="ml-3"
              style="color: #fff"
              @click="checarForm(props.item)"
            >
              <span>Salvar e enviar para análise</span>
            </v-btn>
          </div>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
</template>
<script>
import AppModalShowEvidence from "@/modules/diagnostic/components/ModalShowEvidence";
import { mapActions, mapGetters } from "vuex";
import { evidenceQuestionAPI } from "@/modules/evidence";
import Swal from "sweetalert2";
import { cityQuestionAPI } from "@/modules/city";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import { rulesFile } from "../utils";
export default {
  components: {
    AppModalShowEvidence,
  },
  props: {
    visualizarPontosMedalha: { type: Boolean, required: true },
    perguntasRespondidas: { type: Array, required: true },
    headers: { type: Array, required: true },
    headersSemPontos: { type: Array, required: true },
    payload: { type: Object, Array: true },
    expanded: { type: Array, required: true },
    evidences: { type: Array, required: true },
    rulesArquivo: { type: Array, required: true },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      visualizarComplemento: false,
      valorDiagnostico: 0,
      verComplemento: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    checkCarregar(pergunta) {
      const pdfRules = rulesFile(
        pergunta.perguntaId,
        pergunta.quantidadeArquivo,
        pergunta.quantidadeArquivoDadosComplementares,
        this.valorDiagnostico,
        pergunta.atualizacaoAtendentes
      );

      if (!pergunta.arquivos || pergunta.arquivos.length == 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
        return;
      } else if (pdfRules) {
        this.$notification.error(pdfRules);
      } else {
        pergunta.perguntaId == 3
          ? this.$emit("sendEvidences", pergunta, false, true)
          : this.$emit("sendEvidences", pergunta, false, false);
      }
    },
    downloadEvidence(evidence) {
      this.setLoading(true);
      evidenceQuestionAPI
        .download(evidence.perguntaEvidenciaId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          // link.download = evidence.nomeArquivo;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter evidencia");
        });
    },
    perguntaAnalise(pergunta) {
      Swal.fire({
        title: "Enviar a análise!",
        text: `Ao enviar a análise só poderá ser alterada em caso de rejeição. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("enviarAnalise", pergunta);
        } else {
          this.setLoading(false);
        }
      });
    },
    checkSalvarDados(pergunta) {
      if (pergunta.arquivosDados) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(pergunta.perguntaMunicipioId)
          .then((resp) => {
            pergunta.evidence = resp.data.evidencias;

            if (
              pergunta.arquivosDados &&
              pergunta.evidence.find((item) =>
                item.nomeArquivo.includes("DADOS_COMPLE_")
              )
            ) {
              Swal.fire({
                title: "Arquivo já existente",
                html: `
            Já existe um arquivo de dados complementares associado a essa pergunta. 
            <div style="margin: 15px 0">Caso queira modifica-lo, poderá excluí-lo na seção <strong>Evidências</strong> acima de Dados Complementares.</div> 
             <div>Arquivos de dados complementares começam por <strong>DADOS_COMPLE </strong></div>`,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
              });
              this.setLoading(false);
              return;
            } else {
              this.$emit("sendEvidences", pergunta, false, true);
            }
          })
          .catch(() => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      } else {
        this.$emit("sendEvidences", pergunta, false, true);
      }
    },
    checarForm(pergunta) {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(pergunta.perguntaMunicipioId)
        .then((resp) => {
          pergunta.evidence = resp.data.evidencias;

          let hasArquivoDados =
            pergunta.evidence.find((item) =>
              item.nomeArquivo.includes("DADOS_COMPLE_")
            ) || pergunta.arquivosDados;

          let hasArquivos =
            pergunta.evidence.find(
              (item) => !item.nomeArquivo.includes("DADOS_COMPLE_")
            ) || pergunta.arquivos.length > 0;

          if (
            pergunta.valorInformado &&
            pergunta.atualizacaoAtendentes &&
            !!hasArquivoDados &&
            !!hasArquivos &&
            pergunta.perguntaId == 3
          ) {
            this.verComplemento = false;
            this.perguntaAnalise(pergunta);
          } else if (
            (!pergunta.valorInformado ||
              !pergunta.atualizacaoAtendentes ||
              (!hasArquivoDados &&
                this.valorDiagnostico != pergunta.atualizacaoAtendentes) ||
              !hasArquivos) &&
            pergunta.perguntaId == 3
          ) {
            Swal.fire({
              title: "Campos obrigatórios",
              html: `
            ${
              !pergunta.valorInformado
                ? '<div style="margin-top:20px">Mínimo de horas por atendente é obrigatório</div>'
                : ""
            }
            ${
              !pergunta.atualizacaoAtendentes
                ? '<div style="margin-top:20px">Quantidade atual de atendentes é obrigatória</div>'
                : ""
            }
            ${
              !hasArquivoDados &&
              this.valorDiagnostico != pergunta.atualizacaoAtendentes
                ? '<div style="margin-top:20px">Arquivo de declaração da alteração da quantidade de atendentes é obrigatório</div>'
                : ""
            }
             ${
               !hasArquivos
                 ? '<div style="margin-top:20px">É necessário ao menos uma evidência</div>'
                 : ""
             }
            `,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            this.setLoading(false);
          } else if (!hasArquivos && pergunta.perguntaId != 3) {
            Swal.fire({
              title: "Campos obrigatórios",
              html: `
             ${
               !hasArquivos
                 ? '<div style="margin-top:20px">É necessário ao menos uma evidência</div>'
                 : ""
             }
            `,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            this.setLoading(false);
          } else {
            this.verComplemento = false;
            this.perguntaAnalise(pergunta);
          }
        })
        .catch(() => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    getRespostaDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(this.isParceiro ? 106 : 133, this.$route.params.id)
        .then((resp) => {
          this.valorDiagnostico =
            resp.data && resp.data.length && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    perguntaDelete(evidence) {
      Swal.fire({
        title: `Excluir evidência`,
        text: `Deseja excluir a evidência ${evidence.nomeArquivo}? Esta operação não poderá ser desfeita. `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteFile(evidence);
        }
      });
    },
    deleteFile(evidence) {
      this.setLoading(true);
      evidenceQuestionAPI
        .delete(evidence.perguntaEvidenciaId)
        .then(() => {
          this.$emit("load");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter deletar arquivo");
        });
    },
  },
  mounted() {
    this.getRespostaDiagnostico();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isSala",
      "isAnalista",
      "isParceiro",
      "isFullAdmin",
    ]),
  },
};
</script>
<style>
.respo .complemento .v-input__control {
  background: #fff;
}

.pergunta3 .v-file-input__text {
  color: #fff !important;
}
.pergunta3 .v-text-field .v-label {
  color: #f5f5f5 !important;
}

.pergunta3 {
  background: #2d6189 !important;
  color: #fff;
}
.pergunta3:hover {
  background: #225a85 !important;
  color: #fff;
}
.respo .complemento {
  background: #f5f5f5;
}
</style>
<style scoped lang="scss">
.evidencias {
  padding: 10px 30px !important;
  .titulo2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .nomeEvidencia {
    cursor: pointer;
    color: #2d6189;
    font-weight: bold;
  }

  .nomeEvidencia:not(:last-of-type) {
    border-right: 1px solid #dfdfdf;
    padding-right: 20px;
  }

  .agrupEvidencias {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
  }
}

.complemento td {
  padding: 10px 30px !important;
}
.titulo {
  font-size: 20px;
  margin: 1rem 0;
}
.perguntas {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;

  ._nome {
    max-width: 70%;
  }
}
</style>
